// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-wrapper-info-date":"styles__view-slider-item-wrapper-info-date__1l9Vl","viewSliderItemWrapperInfoDate":"styles__view-slider-item-wrapper-info-date__1l9Vl"};